accounts-app {
  pg-account-selector {
    display: none;
  }
}
